module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-68.7651b0f6.svg";